import {where} from "firebase/firestore";
import {contarSumaWhere} from "../../Servicios/BD/Contadores/contarSumaWhere";

export const obtenerTotalContratosActivos = async (idUsuario) => {

    //Las cuentas salen de movimientos

    let w = [where('idUsuario', '==', idUsuario), where('estado', 'in', ['Activo','No Bonos', 'No Rendimientos'])];
    let dox = await contarSumaWhere({coleccion: 'contratos', wheres: w, propiedad: 'valor'})
   // console.log(dox)


    if (dox.res) {
        return dox.data
    } else {
        return 0
    }


    //Falta restar los gastos ( compra contratos, pago de menbresia

}